import React from "react";
import "../styles/LockerFacility.css";

function LockerFacility() {

const branches = [
{
name: "Chirabazar Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹800"},
{type:"C",price:"₹800"},
{type:"D",price:"₹1000"},
{type:"E",price:"₹1000"},
{type:"F",price:"₹2000"},
{type:"G",price:"₹2000"}
]
},
{
name: "Vithalwadi Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹1000"},
{type:"C",price:"₹1800"},
{type:"D",price:"₹2000"}
]
},
{
name: "Kandiwali Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹1000"},
{type:"C",price:"₹1200"},
{type:"D",price:"₹2000"},
{type:"E",price:"₹2400"},
{type:"F",price:"₹4000"}
]
},
{
name: "Satara Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹1000"},
{type:"C",price:"₹2000"}
]
},
{
name: "Kamothe Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹1000"},
{type:"C",price:"₹2000"}
]
},
{
name: "Bhiwandi Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹1000"},
{type:"C",price:"₹2000"}
]
},
{
name: "Dombivali Branch",
lockers: [
{type:"A",price:"₹800"},
{type:"B",price:"₹1000"},
{type:"C",price:"₹2000"},
{type:"D",price:"₹2000"}
]
}
];

return (

<div className="locker-wrapper">

{/* HERO */}

<section className="locker-hero">


<h1>Secure Locker Facility</h1>

<p>
Protect your valuables with our high security bank lockers.
Safe, reliable and available across multiple branches.
</p>


</section>

{/* ABOUT */}

<section className="locker-about">

<div className="about-text">

<h2>Safe Deposit Locker Facility</h2>

<p>
The care and safety of your valuables are taken by the bank by offering a secure safe deposit locker facility.
Customers can store important documents, jewellery, and other valuables with complete confidence.
</p>

<p>
Lockers can be hired by individuals singly or jointly as well as by partnership firms.
The annual rent depends on the locker size and branch availability.
</p>

</div>

<img
src="https://plus.unsplash.com/premium_photo-1754473569994-37b6e1c93a77?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGJhbmslMjBsb2NrZXIlMjBzZXJ2aWNlfGVufDB8fDB8fHww"
alt="locker vault"
/>

</section>

{/* SECURITY FEATURES */}

<section className="locker-features">

<h2>Why Choose Our Locker Facility</h2>

<div className="features-grid-lockerpage">

<div className="feature-card-lockerpage">
<h3>🔐 High Security Vault</h3>
<p>Modern vault systems with advanced security protocols.</p>
</div>

<div className="feature-card-lockerpage">
<h3>🎥 CCTV Monitoring</h3>
<p>Locker areas are monitored with surveillance cameras.</p>
</div>

<div className="feature-card-lockerpage">
<h3>🗝 Dual Key System</h3>
<p>Two key protection system ensures maximum security.</p>
</div>

<div className="feature-card-lockerpage">
<h3>🏦 Multiple Branches</h3>
<p>Locker facilities available at various branches.</p>
</div>

</div>

</section>

{/* LOCKER PRICING */}

<section className="locker-pricing">

<h2>Branch Wise Locker Rent</h2>

<p className="note">
*Figures in INR. GST @18% extra. Locker allotment subject to availability.
</p>

<div className="branches-grid-locker">

{branches.map((branch,index)=>(
<div className="branch-card-locker" key={index}>

<h3>{branch.name}</h3>

<div className="locker-types">

{branch.lockers.map((locker,i)=>(
<div className="locker-chip" key={i}>
<span>Type {locker.type}</span>
<strong>{locker.price}</strong>
</div>
))}

</div>

</div>
))}

</div>

</section>

{/* DOCUMENTS */}

<section className="locker-docs">

<h2>Documents Required</h2>

<div className="docs-grid-lockerpage">

<div className="doc-card-lockerpage">Aadhaar Card</div>
<div className="doc-card-lockerpage">PAN Card</div>
<div className="doc-card-lockerpage">Passport Photo</div>
<div className="doc-card-lockerpage">Bank Account with our branch</div>

</div>

</section>

{/* CTA */}

<section className="locker-cta">

<h2>Secure Your Valuables Today</h2>

<p>Contact your nearest branch to check locker availability.</p>

<a href="/branches" className="locker-btn">
Locate Branches
</a>

</section>

</div>

);

}

export default LockerFacility;